<div
  class="quality-icon"
  [ngClass]="{
    'selected-by-qa': this.isRequestedByQualityAnalyst()
  }"
  [matTooltip]="tooltip"
  matTooltipClass="custom-tooltip"
>
  @if (iconName) {
  <span class="material-symbols-outlined" (click)="onIconClick()">{{
    iconName
  }}</span>
  } @if (label) {
  <span class="quality-label">{{ label }}</span>
  } @if (canShowPlusIcon()) {
  <button class="plus-icon" mat-icon-button (click)="onPlusIconClick()">
    <mat-icon>add_circle</mat-icon>
  </button>
  }
</div>
